import {
  RepeatWrapping,
  Sprite,
  SpriteMaterial,
  TextureLoader,
  Vector2
} from 'three'

/**
 * 精灵图标记
 */
class SpriteMarker extends Sprite {
  constructor() {
    super()
    this.enabled = false
    this.animation = false
    this.init()
  }
  init() {
    this.material = new SpriteMaterial({
      map: null,
      sizeAttenuation: false,
      depthTest: false
    })
    this.material = this.material
  }
  changeAttr(fps_, keynum_, texture, w_, h_, animation_) {
    this.enabled = false
    this.fps = fps_
    this.fpsTime = 1000 / this.fps
    this.histTime = 0
    this.keyframes = keynum_
    this.curKey = 0
    this.offsetStep = 1 / this.keyframes
    this.offset = 0
    let spTexture = new TextureLoader().load(texture)
    spTexture.wrapS = RepeatWrapping
    spTexture.wrapT = RepeatWrapping
    spTexture.repeat.set(1, 1 / (this.keyframes - 1))
    spTexture.offset.set(0, this.offsetStep)
    if (this.texture) {
      this.texture.dispose()
      this.texture = null
    }
    let size = new Vector2(w_, h_)
    size.multiplyScalar(1 / (window.devicePixelRatio * window.innerWidth))
    this.scale.copy(size)
    this.texture = spTexture
    this.material.map = this.texture
    this.material.needsUpdate = true
    this.texture.needsUpdate = true
    this.enabled = true
    this.animation = animation_
  }
  updatePosition(videoPro){
    if(videoPro>this.showStart&&videoPro<showEnd) {
      // 控制标记显示
      this.visible = true;
      // 计算补间动画
      // s 1 获取持续时间
      // s2  获取 开始位置与结束位置
      // new vector2(end) - new Vector(start) 求出二维平面坐标
      // 求出 球坐标 phi theta  再用球坐标转换全景图空间坐标   utils.getPanoPosition
      // s3 计算 补间距离
      // s4 起始点位置 加上补间位置
    }
    else this.visible = false
  }
  update(delta_) {
    // 标记尚未准备好
    if (!this.enabled) return
    // 标记不需要动画
    if (!this.animation) return
    // 标记动画帧数只有一帧
    if (this.keyframes <= 1) return
    var now = Date.now()
    if (now - this.histTime > this.fpsTime) {
      this.histTime = now
      this.curKey++
      this.curKey = this.curKey % this.keyframes
      this.offset = this.curKey * this.offsetStep
      this.texture.offset.set(0, this.offset)
    }
  }
  dispose() {
    if (this.texture) this.texture.dispose()
    if (this.material) this.material.dispose()
    this.enabled = false
    this.animation = false
    this.texture = null
    this.material = null
  }
}
export { SpriteMarker }



// WEBPACK FOOTER //
// ./src/webgl/marker/SpriteMarker.js